// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.attachment-sended-temp-wrapper.attachment-wrap {
  justify-content: flex-start;
  word-break: break-word;
}

.thumbnails-wrapper.document-template {
  justify-content: flex-start;
}
.thumbnails-wrapper.document-template .document-cotent {
  width: 50%;
}`, "",{"version":3,"sources":["webpack://./src/templatemanager/templates/templateAttachment/templateAttachment.scss"],"names":[],"mappings":"AACI;EACI,2BAAA;EACA,sBAAA;AAAR;;AAKI;EACI,2BAAA;AAFR;AAIQ;EACI,UAAA;AAFZ","sourcesContent":[".attachment-sended-temp-wrapper {\n    &.attachment-wrap {\n        justify-content: flex-start;\n        word-break: break-word;\n    }\n}\n\n.thumbnails-wrapper {\n    &.document-template {\n        justify-content: flex-start;\n\n        .document-cotent {\n            width: 50%;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
